import ErrorMessage from '../ErrorMessage';

export default class ScreenShareNotSupportError extends Error {
  name = ErrorMessage.SCREEN_SHARE_NOT_SUPPORT;
}
